import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";
import { makeHttpRequest } from "helper/helper";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const firebaseApp = initializeApp(firebaseConfig);

const VAPID_KEY =
  "BLQU-vChGInbwzDtVRww2pJ570Z1r_iOg4_IHVZXAjZWrr1OXdFrg9PK5Y4SjoBohhKsdw5gjEWNi6oGqnzzqmI";

// Jangan panggil getMessaging() di module level. Di Safari iOS (tab biasa) web push
// tidak didukung, dan getMessaging() akan throw sehingga module gagal di-load dan
// aplikasi blank / login gagal. Cek dukungan dulu, kembalikan null kalau tidak didukung.
const getMessagingIfSupported = async () => {
  try {
    if (typeof Notification === "undefined") return null;
    if (!(await isSupported())) return null;
    return getMessaging(firebaseApp);
  } catch (err) {
    console.log("firebase messaging not supported:", err);
    return null;
  }
};

export const requestPermission = async (token_user) => {
  try {
    const messaging = await getMessagingIfSupported();
    // Browser tidak mendukung (mis. Safari HP) -> lewati, jangan pernah blok login.
    if (!messaging) return;

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.log("user permission denied");
      return;
    }

    const currentToken = await getToken(messaging, { vapidKey: VAPID_KEY });
    if (!currentToken) {
      console.log("failed to generate token");
      return;
    }

    const response = await makeHttpRequest(
      `firebase/subscribe-token`,
      "POST",
      {},
      { token: currentToken },
      token_user
    );
    console.log(response.status ? "success to subscribe token" : "failed to subscribe token");
  } catch (err) {
    console.log("error firebase occured", err);
  }
};

export const onMessageListener = async () => {
  const messaging = await getMessagingIfSupported();
  if (!messaging) return null;

  return new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log("onMessageListener", payload);
      resolve(payload);
    });
  });
};
